import gql from 'graphql-tag';

export default gql`
  mutation createTreatment($input: CreateTreatmentInput!) {
    createTreatmentWithValidation(input: $input) {
      id
    }
  }
`;
